export const getUserLocation = (): Promise<{
  latitude: number;
  longitude: number;
}> => {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error("Geolocation is not supported"));
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
      },
      (error) => {
        reject(error);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      },
    );
  });
};

export const isNearbyKeyword = (keyword: string): boolean => {
  const normalized = normalizeNearbyKeyword(keyword);

  return /\bnearby\b/i.test(normalized);
};

export const getSearchKeyword = (keyword: string): string => {
  const normalized = normalizeNearbyKeyword(keyword);

  return normalized
    .replace(/\bnearby\b/g, "")
    .replace(/\s+/g, " ")
    .trim();
};

export const normalizeNearbyKeyword = (keyword: string): string => {
  return keyword
    .toLowerCase()
    .trim()
    .replace(/\bnear\s+by\b/g, "nearby")
    .replace(/\bnear\s+me\b/g, "nearby")
    .replace(/\bnearme\b/g, "nearby")
    .replace(/\bnear\b/g, "nearby")
    .replace(/\s+/g, " ")
    .trim();
};
export const STOP_WORDS = new Set([
  "in",
  "at",
  "the",
  "and",
  "or",
  "of",
  "to",
  "for",
  "a",
  "an",
  "is",
  "are",
  "business",
  "businesses",
  "best",
  "good",
  "top",
  "popular",
  "famous",
  "nearby",
]);
